import { createContext, useContext, useEffect, useState } from "react";
import { getUserProfile } from "../Services/MyProfile";

// Create a context for the header
const HeaderContext = createContext();

export const useHeader = () => {
  return useContext(HeaderContext);
};

export const HeaderProvider = ({ children }) => {
  const [headerContent, setHeaderContent] = useState(true);
  const [headerContentRightSideContent, setHeaderContentRightSideContent] =
    useState(true);
  const [profileContent, setprofileContentD] = useState(() => {
    const storedProfile = localStorage.getItem("profile");
    return storedProfile && storedProfile !== "undefined"
      ? JSON.parse(storedProfile)
      : null;
  });

  const [beliefSystem, setbeliefSystem] = useState({});
  const [isCoachingActive, setIsCoachingActive] = useState(false);
  const [isChatHistoryOpen, setIsChatHistoryOpen] = useState(false);

  const PROFILE_STORAGE_KEY = "profile";

  const fetchProfileData = async () => {
    try {
      // Prefer cached profile from localStorage
      const storedProfile = localStorage.getItem(PROFILE_STORAGE_KEY);
      if (storedProfile && storedProfile !== "undefined") {
        const parsed = JSON.parse(storedProfile);
        setprofileContentD(parsed);
        return; // Do not make API call if cache exists
      }

      // Fallback to API if no cache
      const response = await getUserProfile();
      if (response) {
        // Store in localStorage
        localStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(response));
        // Update state
        setprofileContentD(response);
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  useEffect(() => {
    // Call API immediately when component mounts
    fetchProfileData();

    // Set interval to call API every 6 seconds
    const intervalId = setInterval(() => {
      fetchProfileData();
    }, 24 * 60 * 60 * 1000);

    // Cleanup the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const addProfileData = () => {
    setprofileContentD(() => {
      const storedProfile = localStorage.getItem("profile");
      return storedProfile && storedProfile !== "undefined"
        ? JSON.parse(storedProfile)
        : null;
    });
  };

  return (
    <HeaderContext.Provider
      value={{
        headerContent,
        setHeaderContent,
        headerContentRightSideContent,
        setHeaderContentRightSideContent,
        profileContent,
        addProfileData,
        beliefSystem,
        setbeliefSystem,
        isCoachingActive,
        setIsCoachingActive,
        isChatHistoryOpen,
        setIsChatHistoryOpen,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};
